"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateDeeplinkOrWebFallbackUrl = exports.addWebClientIdToOneLink = exports.addWebClientIdToURL = void 0;
const addWebClientIdToURL = (url, webClientId) => {
    if (url === "")
        return url;
    const parsedUrl = new URL(url);
    parsedUrl.searchParams.set("web_client_id", webClientId);
    return parsedUrl.toString();
};
exports.addWebClientIdToURL = addWebClientIdToURL;
const addWebClientIdToOneLink = (oneLink, webClientId) => {
    if (!webClientId || oneLink === "") {
        return oneLink;
    }
    const oneLinkUrl = new URL(oneLink);
    const deepLink = oneLinkUrl.searchParams.get("af_dp");
    if (deepLink) {
        const deepLinkUrl = new URL(deepLink);
        oneLinkUrl.searchParams.set("af_dp", (0, exports.addWebClientIdToURL)(deepLinkUrl.toString(), webClientId));
    }
    return oneLinkUrl.toString();
};
exports.addWebClientIdToOneLink = addWebClientIdToOneLink;
const generateDeeplinkOrWebFallbackUrl = (pageURL, pageTypeString, webClientId) => {
    if (pageURL === "")
        return pageURL;
    // Print a message in the console if we run this function on existing one links:
    if (pageURL.startsWith("https://click.snapchat.com")) {
        if (process.env.NODE_ENV !== "production") {
            console.error(`'${pageURL}' is already a one link`);
        }
        return pageURL;
    }
    const pageUrlWithWCID = new URL(pageURL);
    if (webClientId) {
        pageUrlWithWCID.searchParams.set("web_client_id", webClientId);
    }
    const encodedPageUrlWithWCIDString = encodeURIComponent(pageUrlWithWCID.toString());
    return (`https://click.snapchat.com/aVHG?` +
        `pid=consumer_web` +
        `&c=${pageTypeString}` +
        `&af_js_web=true` +
        `&af_dp=${encodedPageUrlWithWCIDString}` +
        `&af_web_dp=${encodedPageUrlWithWCIDString}` +
        `&af_ios_url=${encodedPageUrlWithWCIDString}` +
        `&af_android_url=${encodedPageUrlWithWCIDString}`);
};
exports.generateDeeplinkOrWebFallbackUrl = generateDeeplinkOrWebFallbackUrl;
//# sourceMappingURL=web-client-id-utils.js.map